import { Injectable } from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Observable
} from 'rxjs';

import {
  environment
} from '../../environments/environment';


export interface CriarReservaRequest {
  quartoId: number;
  checkIn: string;
  checkOut: string;
  quantidadeHospedes: number;
  quantidadeCriancas?: number;
  quantidadeAnimais?: number;
  hospedes: {
    nome: string;
    sobrenome: string;
    email: string;
    telefone: string;
    cpf: string;
  }[];
}


export interface EditarDatasReservaRequest {
  checkIn: string;
  checkOut: string;
}



export interface HospedeResponse {

  nome: string;

  sobrenome: string;

  email: string;

  telefone: string;

  cpf: string;

}


export interface PacoteReservaResponse {

  id: number;

  pacoteAdicionalId: number;

  nome: string;

  valor: number;

}


export interface ReservaResponse {

  id: number;

  quartoId: number;

  quartoNome: string;

  quantidadeHospedes: number;

  quantidadeCriancas: number | null;

  quantidadeAnimais: number | null;

  checkIn: string;

  checkOut: string;

  quantidadeNoites: number;

  valorOriginal: number | null;

  valorDesconto: number | null;

  codigoCupom: string | null;

  valorTotal: number;

  status: string;

  hospedes: HospedeResponse[];

  pacotes: PacoteReservaResponse[];

  criadoEm: string;

  invoiceUrl?: string | null;

}


@Injectable({
  providedIn: 'root'
})
export class ReservaService {


  private api =
    `${environment.apiUrl}/reservas`;


  constructor(
    private http: HttpClient
  ) {}


  criar(
    dados: CriarReservaRequest
  ): Observable<ReservaResponse> {

    return this.http.post<ReservaResponse>(
      this.api,
      dados
    );

  }


  editarDatas(
    reservaId: number,
    dto: EditarDatasReservaRequest
  ): Observable<ReservaResponse> {
    return this.http.patch<ReservaResponse>(
      `${this.api}/${reservaId}/datas`,
      dto
    );
  }



  listar(): Observable<ReservaResponse[]> {

    return this.http.get<ReservaResponse[]>(
      this.api
    );

  }


  buscarPorId(
    id: number
  ): Observable<ReservaResponse> {

    return this.http.get<ReservaResponse>(
      `${this.api}/${id}`
    );

  }


  cancelar(
    id: number
  ): Observable<ReservaResponse> {

    return this.http.post<ReservaResponse>(
      `${this.api}/${id}/cancelar`,
      {}
    );

  }


  buscarReservas(
    termo: string
  ): Observable<ReservaResponse[]> {

    return this.http.get<ReservaResponse[]>(
      `${this.api}/buscar?busca=${encodeURIComponent(termo)}`
    );

  }

}
